module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/hash_icon_bk-f591e7085bc6ad3d21532f2e70a12966.png";